import { RootState } from '@/shared/types/state';

export const isSkippingAppVersion = (state: RootState): boolean => {
  return state.appVersion.skipAppVersion;
};
